import React, { useEffect, useState } from "react"
import {observer} from "mobx-react-lite"
import {useRootStore} from "../../../../RootStateContext"
import {Accordion, Card, Col, Form, Row, Button} from "react-bootstrap"

const Users = observer(() => {
    const {userStore} = useRootStore()
    const {users, getUsers, createUser, userCreateResult, updateUser} = userStore

    const [name, setName] = useState('')
    const [password, setPassword] = useState('')
    const [email, setEmail] = useState('')
    const [role, setRole] = useState('admin')

    const [currentUserRole, setCurrentUserRole] = useState('')
    const [currentUserStatus, setCurrentUserStatus] = useState('')
    const [currentUserPassword, setCurrentUserPassword] = useState('')
    const [currentUserPasswordConfirm, setCurrentUserPasswordConfirm] = useState('')
    const [passwordError, setPasswordError] = useState('')
    
    useEffect(() => {
        getUsers()
    }, [])

    const handleSubmit = (event: any) => {
        event.preventDefault()
        event.stopPropagation()
        
        createUser(email,password,role,name)
        setName('')
        setPassword('')
        setEmail('')
        setRole('admin')
    }

    const UpdateUser = (id: number, defaultRole: string, defaultStatus: string) => {
        
        if(currentUserPassword === '') return

        let userId = id
        let role, status, password      
        currentUserRole === '' ? role = defaultRole : role = currentUserRole
        currentUserStatus === '' ? status = defaultStatus : status = currentUserStatus
        
        if(currentUserPassword === currentUserPasswordConfirm) {
            password = currentUserPassword
            updateUser(userId, password, status, role)
            setPasswordError('')
        } else {
            setPasswordError('Введенные пароли не совпадают')
            
        }

        setCurrentUserRole('')
        setCurrentUserStatus('')
        setCurrentUserPassword('')
        setCurrentUserPasswordConfirm('')
    }

    const onOpen = () => {
        console.log('open');
        
    }

    return (
        <>
            <Card className="mb-3">
                <Card.Body>
                    <Card.Title>Добавление сотрудника</Card.Title>
                    <Form onSubmit={handleSubmit} autoComplete="off">
                        <Row className="mb-3">
                            <Form.Group as={Col}>
                                <Form.Label htmlFor="newUserName">Имя</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="newUserName"
                                    size="sm"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label htmlFor="newUserPass">Пароль</Form.Label>
                                <Form.Control
                                    type="password"
                                    id="newUserPass"
                                    size="sm"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col}>
                                <Form.Label htmlFor="newUserEmail">Email</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="newUserEmail"
                                    size="sm"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>Роль</Form.Label>
                                <Form.Select 
                                    size="sm"
                                    value={role}
                                    onChange={(e) => setRole(e.target.value)}
                                >
                                    <option value="admin">admin</option>
                                    <option value="dispatcher">dispatcher</option>
                                </Form.Select>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Col sm={2}>
                                <Button variant="primary" type="submit">
                                    Добавить
                                </Button>
                            </Col>
                            <Col>
                            {/* <Alert variant="success" show={userCreateResult !== undefined || userCreateResult?.length > 0}>
                                Сотрудник успешно добавлен!
                            </Alert> */}
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>
            {users?.map(user => {
                return (
                    <Accordion key={user.id}>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                <strong>{user.id}</strong>
                                &nbsp;
                                {user.name}
                                &nbsp;/&nbsp;
                                {user.email}
                            </Accordion.Header>
                            <Accordion.Body>
                                <Card key={user.id}>
                                    <Card.Body>
                                        <Row className="mb-3">
                                            <Form.Group as={Col}>
                                                <Form.Label>Статус</Form.Label>
                                                <Form.Select 
                                                    size="sm" 
                                                    defaultValue={user.status}
                                                    onChange={e => setCurrentUserStatus(e.target.value)}
                                                >
                                                    <option value="blocked">blocked</option>
                                                    <option value="active">active</option>
                                                </Form.Select>
                                            </Form.Group>
                                            <Form.Group as={Col}>
                                                <Form.Label>Роль</Form.Label>
                                                <Form.Select 
                                                    size="sm" 
                                                    defaultValue={user.role}
                                                    onChange={e => setCurrentUserRole(e.target.value)}
                                                >
                                                    <option value="admin">admin</option>
                                                    <option value="dispatcher">dispatcher</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} >
                                                <Form.Label htmlFor={`userPass${user.id}`}>Новый пароль</Form.Label>
                                                <Form.Control
                                                    type="password"
                                                    id={`userPass${user.id}`}
                                                    size="sm"
                                                    value={currentUserPassword}
                                                    onChange={e => setCurrentUserPassword(e.target.value)}
                                                />
                                            </Form.Group>
                                            <Form.Group as={Col}>
                                                <Form.Label htmlFor={`userPassConfirm${user.id}`}>Подтвердите пароль</Form.Label>
                                                <Form.Control
                                                    type="password"
                                                    id={`userPassConfirm${user.id}`}
                                                    size="sm"
                                                    value={currentUserPasswordConfirm}
                                                    onChange={e => setCurrentUserPasswordConfirm(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Row>
                                        {/* <Row>
                                            <Col>
                                                <Alert variant="danger" show={passwordError !== ''}>
                                                    {passwordError}
                                                </Alert>
                                            </Col>
                                        </Row> */}
                                        <Row>
                                            <Col sm={2}>
                                                <Button 
                                                    variant="primary"
                                                    onClick={() => UpdateUser(user.id, user.role, user.status)}
                                                >
                                                    Обновить
                                                </Button>
                                            </Col>
                                            <Col>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                )
            })}
        </>
    )
})

export default Users